import { Equipment, Point } from "@/models/equipment.model";
import { Component, Prop, Vue } from "vue-property-decorator";
import ScatterGraph from "./parts/ScatterGraph/index.vue";

@Component({
  components: { ScatterGraph },
})
export default class AbacusModal extends Vue {
  @Prop() categoryTitle!: string;
  @Prop() equipment!: Equipment;

  closeModal(): void {
    this.$emit("close");
  }

  get compareTitle(): any {
    return this.$t("components.popinAbacus.modalTitleCompare")
  }

  get options(): any {
    return {
      scales: {
        x: {
          title: {
            display: true,
            text: this.$t("components.popinAbacus.xLabel"),
          },
        },
        y: {
          title: {
            display: true,
            text: this.$t("components.popinAbacus.yLabel"),
          },
        },
      },
    };
  }

  /**
   * data used to generate line chart
   *
   **/
  get chartData(): {
    datasets: {
      label: string;
      data: Point[];
      fill: boolean;
      borderColor: string;
      borderWidth: number;
      showLine: boolean;
    }[];
  } {
    return {
      datasets: [
        {
          label: this.$t("components.popinAbacus.graphLabel").toString(),
          data: this.getData,
          fill: false,
          borderColor: this.$t("components.popinAbacus.borderColor").toString(),
          borderWidth: 3,
          showLine: true,
        },
      ],
    };
  }

  /**
   * get y axis of each point to define datas
   *
   **/
  get getData(): Point[] {
    if (this.equipment.abacus) {
      return this.equipment.abacus;
    } else {
      return [{ x: 0, y: 0 }];
    }
  }
}
